module.exports = __webpack_public_path__ + "static/img/sustainable-performance_03_2025.e00939f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/sustainable-performance_03_2025.jpg
// module id = t+AL
// module chunks = 99